
(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "May", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Oct", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.547"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.547",
    "da": "static-7.547",
    "de": "static-7.547",
    "el": "static-7.547",
    "en": "static-7.547",
    "es-mx": "static-7.547",
    "es": "static-7.547",
    "fi": "static-7.547",
    "fr": "static-7.547",
    "hr": "static-7.547",
    "id": "static-7.547",
    "it": "static-7.547",
    "ja": "static-7.547",
    "ko": "static-7.547",
    "nl": "static-7.547",
    "no": "static-7.547",
    "pl": "static-7.547",
    "pt-br": "static-7.547",
    "ro": "static-7.547",
    "ru": "static-7.547",
    "sv": "static-7.547",
    "th": "static-7.547",
    "vi": "static-7.547",
    "zh-cn": "static-7.547",
    "zh-hk": "static-7.547"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.547'}); }
})();





//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/ecosystem-marketplace-apps/node_modules/bender-lyaml-loader/lib?{"allowJsx":true,"modern":false}!/usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/lang/en.lyaml?sporks
// module id = 296
// module chunks = 209 210 211 212 213